import { useYupValidationWithoutFormik } from '../../../../../hooks'
import { useFormNoChangesNotification } from '../../../../Form'

export function useFilterModalValidation({
  onRemoveNotification,
  onSetNotification,
}) {
  const { isValidForm, setValidationErrors, validationErrors } =
    useYupValidationWithoutFormik()

  useFormNoChangesNotification({
    errors: validationErrors,
    onRemoveNotification,
    onSetNotification,
  })

  return {
    isValidForm,
    setValidationErrors,
  }
}
